import React from 'react';
import { Link } from 'react-router';

import { yup } from 'data';
import { url } from 'helpers';
import { authService } from 'services';
import { useForm, useLang, useMutation } from 'hooks';
import { PageLayout } from 'layouts';
import { Button, Checkbox, Flex, Form, Input, Paragraph, Title, Trans } from 'components/ui';
import { AuthLoginParams } from 'types/services';

import styles from './styles.module.css';

type FormValues = AuthLoginParams;

const initialValues: FormValues = {
  email: '',
  password: '',
  remember: false,
};

const validationSchema = yup.object({
  email: yup.string().required().email(),
  password: yup.string().required(),
  remember: yup.boolean().optional(),
});

const LoginPage = () => {
  const form = useForm<FormValues>();
  const lang = useLang();

  const loginMutation = useMutation({
    mutationFn: authService.login,
  });

  return (
    <PageLayout title={lang.get('login.title')}>
      <Title>{lang.get('login.heading')}</Title>
      <Paragraph>
        <Trans transKey="login.caption" components={{ Link: <Link to={url.toRegistration()} /> }} />
      </Paragraph>
      <Form
        className={styles.form}
        form={form}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onFinish={loginMutation.mutateAsync}
      >
        <Form.Item name="email" label={lang.get('common.form.email.label')}>
          <Input.Email placeholder={lang.get('common.form.email.placeholder')} />
        </Form.Item>
        <Form.Item name="password" label={lang.get('common.form.password.label')}>
          <Input.Password placeholder={lang.get('common.form.password.placeholder')} />
        </Form.Item>
        <Form.Item>
          <Flex gap="small" justify="space-between" wrap="wrap">
            <Form.CheckboxItem name="remember" noStyle>
              <Checkbox className={styles.remember}>{lang.get('login.remember')}</Checkbox>
            </Form.CheckboxItem>
            <Link className={styles.forgot} to={url.toPasswordReset()}>{lang.get('login.forgot')}</Link>
          </Flex>
        </Form.Item>
        <Flex justify="flex-end">
          <Button htmlType="submit" loading={loginMutation.isPending}>
            {lang.get('login.submit')}
          </Button>
        </Flex>
      </Form>
    </PageLayout>
  );
};

export default LoginPage;
